const getUserAction = ({ actions, project }) => {
  return {
    resource: {
      partition: '*',
      region: '*',
      project: project || '*',
      serviceType: 'iam',
      service: 'user',
      instance: '*',
      actions
    }
  };
};

// eslint-disable-next-line import/prefer-default-export
export { getUserAction };
